import { useState, useEffect } from "react";

import React from "react";

import Pagination from "rc-pagination";
import "../../assets/index.less";
import sendRequest2 from "hooks/useAxios2";
import Transaction from "./FactorTabs";
import AddTransactionModal from "./AddTransactionModal";
import sendRequest from "hooks/useAxios";
export default function TransactionHistory({ setUpdater, updater }) {
  // const [updater, setUpdater] = useState(false);
  const [transact, setTransact] = useState([
    //     {
    //       typeOfTransact:"آنلاین",
    //       transferFrom: "1245678",
    //       numberOfOrder: "1234",
    //       date: "1400/2/16",
    //       price: "100000"
    //     }
  ]);

  useEffect(() => {
    sendRequest2("list_transactions", { muid: 4, order_id: 6 }).then(
      ({ data }) => {
        setTransact(data.result.transactions);
      }
    );
  }, [updater]);
  const [currentPage, setCurrentPage] = useState(1);
  const sliceArray = array => {
    return array.slice((currentPage - 1) * 6, (currentPage - 1) * 6 + 6);
  };
  const [selectId, setSelectId] = useState();

  return (
    <>
      <AddTransactionModal
        type="newtransaction"
        setUpdater={setUpdater}
        updater={updater}
      ></AddTransactionModal>

      {sliceArray(transact).map(value => {
        return (
          <Transaction
            setUpdater={setUpdater}
            updater={updater}
            // selectId={selectId}
            setSelectId={setSelectId}
            value={value}
            typeOfTransact={value.type}
            transferFrom={value.fname + " " + value.lname}
            numberOfOrder={value.order_code}
            price={value.amount}
            date={value.paid_tm}
          ></Transaction>
        );
      })}
      <Pagination
        className="text-center my-2"
        total={transact.length}
        pageSize={6}
        hideOnSinglePage={true}
        current={currentPage}
        onChange={page => {
          setCurrentPage(page);
        }}
      />
    </>
  );
}
